import { render, staticRenderFns } from "./AdsMonitoringList.vue?vue&type=template&id=26976708"
import script from "./AdsMonitoringList.vue?vue&type=script&lang=js"
export * from "./AdsMonitoringList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports